import React, { useMemo } from 'react';

import { IonGrid } from '@ionic/react';

import clsx from 'clsx';

import ChartOrigin from './components/Chart';
import ChartEmpty from './components/ChartEmpty';
import ChartError from './components/ChartError';
import ChartSkeleton from './components/ChartSkeleton';
import './index.css';

const Chart = ({
  isRefetching,
  isLoading,
  isError,
  isSuccess,
  error,
  data,
  showMetricsModal,
}: any) => {
  const isEmpty = useMemo(() => {
    return (data && data?.labels?.length === 0) ?? true;
  }, [data]);

  const renderComponent = useMemo(() => {
    switch (true) {
      case isError: //Loaded with error response
        return (
          <ChartError
            isRefetching={isRefetching}
            error={error}
            onShowMetricsModal={showMetricsModal}
          />
        );
      case isLoading:
        return <ChartSkeleton />; //No loaded
      case isEmpty:
        return (
          <ChartEmpty
            isRefetching={isRefetching}
            onShowMetricsModal={showMetricsModal}
          />
        ); //Loaded with empty response
      case isSuccess: //Loaded with normal response
        return (
          <ChartOrigin
            isRefetching={isRefetching}
            data={data}
            onShowMetricsModal={showMetricsModal}
          />
        );
      default:
        return null;
    }
  }, [
    isLoading,
    isRefetching,
    isEmpty,
    isSuccess,
    isError,
    data,
    error,
    showMetricsModal,
  ]);
  return (
    <IonGrid data-cy={'Chart'} className={'chart-container ion-no-padding'}>
      <div
        className={clsx({
          'chart-overlay': true,
          'chart-refetching': isRefetching,
        })}
      />
      {renderComponent}
    </IonGrid>
  );
};
export default Chart;
